import React, { useRef, useEffect } from "react";
import { useIsMobile } from "../../functions/deviceIdentity/getDeviceType";
import { askForNotificationPermission, getSubscription } from "../../functions/notifications/notificationFunctions";

const NotificationButtonModal = (props) => {
    const { modalOpen, onClose } = props;
    const ref = useRef();
    const isMobile = useIsMobile();

    const handleNotifcation = async () => {

        if ('Notification' in window && 'serviceWorker' in navigator && 'PushManager' in window) {
            if (Notification.permission === 'default') {
                await askForNotificationPermission();
                await getSubscription();
            } else if (Notification.permission === 'granted') {
                await getSubscription();
            }
        }

        onClose();
    }

    useEffect(() => {
        if (modalOpen) {
            ref.current?.showModal();
        } else {
            ref.current?.close();
        }

    }, [modalOpen]);

    return (
        <dialog className="gt-modal" aria-labelledby="smartAssistant" ref={ref}>
            <div className="gt-modal-content">
                <div className="gt-modal-content__heading">
                    <h2 id="smartAssistant">Notifications</h2>
                </div>
                <div className="gt-modal-content__body">
                    <p id="smartAssistant-text" style={{ textAlign: "justify", padding: "20px", fontSize: "16" }} >
                        Choose to allow notifications on this device.
                    </p>
                </div>
                <div style={{ display: "flex", justifyContent: "space-evenly" }}>
                    <button className="gt-mobile-controls__add"
                        onClick={() => {
                            handleNotifcation();
                        }}>
                        <svg xmlns="http://www.w3.org/2000/svg">
                            <use xlinkHref="#globaltasks-svg-notification"></use>
                        </svg>
                    </button>
                </div>
            </div>
        </dialog>
    );
};

export default NotificationButtonModal;